import { render, staticRenderFns } from "./ChatRecordButton.vue?vue&type=template&id=583e66b9&scoped=true&"
import script from "./ChatRecordButton.vue?vue&type=script&lang=js&"
export * from "./ChatRecordButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e66b9",
  null
  
)

export default component.exports